import React from "react";
import useFetch from "@/lib/useFetch";
import { GlassCard, PageTitle, StatusBadge, EmptyState } from "@/components/lux";
import { money } from "@/lib/api";
import { Receipt } from "lucide-react";

export default function AdminLedger() {
  const { data, loading } = useFetch("/admin/ledger");
  return (
    <div className="space-y-6">
      <PageTitle title="Income Ledger" subtitle="Immutable record of all financial transactions" />
      <GlassCard className="p-6">
        {loading ? <div className="skeleton h-40" /> : data?.ledger?.length ? (
          <div className="max-h-[36rem] overflow-auto">
            <table className="w-full text-sm">
              <thead className="sticky top-0 bg-[var(--bg-2)] text-left text-[var(--text-dim)]"><tr className="border-b border-white/10">
                <th className="py-3">TX ID</th><th className="py-3">Type</th><th className="py-3">Direction</th><th className="py-3">Description</th><th className="py-3">Status</th><th className="py-3">Date</th><th className="py-3 text-right">Amount</th></tr></thead>
              <tbody>
                {data.ledger.map((t, i) => (
                  <tr key={i} className="row-hover border-b border-white/5">
                    <td className="py-3 text-white">{t.tx_id}</td>
                    <td className="py-3 capitalize text-[var(--text-dim)]">{t.type?.replace(/_/g, " ")}</td>
                    <td className="py-3 capitalize">{t.direction}</td>
                    <td className="py-3 text-[var(--text-dim)]">{t.description}</td>
                    <td className="py-3"><StatusBadge status={t.status} /></td>
                    <td className="py-3 text-[var(--text-dim)]">{(t.created_at || "").slice(0, 10)}</td>
                    <td className={`py-3 text-right ${t.direction === "debit" ? "text-rose-300" : "gold-text"}`}>{t.direction === "debit" ? "-" : "+"}${money(t.amount)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : <EmptyState icon={Receipt} title="No ledger entries" />}
      </GlassCard>
    </div>
  );
}
